import { createContext } from 'react';
export var FormGroupsContext = createContext(undefined);
//# sourceMappingURL=FormGroupsContext.js.map